import { Entity } from '@backstage/catalog-model';
import { Content } from '@backstage/core-components';
import { PageShareTitle } from '../../lib/shareTitle';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { getStoredFunMode, translate } from '../i18n';

// The Security tab is fully in-house (no Roadie plugin): the Roadie
// DependabotAlertsTable fetched GraphQL vulnerabilityAlerts(first: 100) —
// the first 100 alerts of ANY state — and filtered to OPEN client-side, so
// repos with >100 total alerts undercounted open ones (and disagreed with
// the Home page Security tab, which uses the REST state=open endpoint).
// DependabotAlertsContent uses that same REST endpoint, so the two surfaces
// always agree. The plugin's other pieces were never wanted either: its
// severity-dismiss modal is broken upstream (hardcodes RoadieHQ/backstage as
// the target repo in v3.3.1) and its code-scanning table errors on every
// service because GitHub Code Security is not enabled on the repos — the
// org runs static analysis in SonarQube, which has its own tab.
//
// Tokens come from the GitHub OAuth popup session, same as the Pull
// Requests tab in modules/github; the GitHub App needs Dependabot alerts:
// Read (see README).
const isSecurityInsightsAvailable = (entity: Entity) =>
  entity.kind.toLocaleLowerCase('en-US') === 'component' &&
  Boolean(entity.metadata.annotations?.['github.com/project-slug']);

export const securityEntityContent = EntityContentBlueprint.make({
  name: 'security',
  params: {
    path: '/security',
    // Non-component config (evaluated once at extension registration), so
    // this reads the fun-mode flag directly instead of the useT() hook — see
    // the i18n module's non-component-code note.
    title: translate('security.entityContent.title', getStoredFunMode()),
    filter: isSecurityInsightsAvailable,
    loader: () =>
      import('./DependabotAlertsContent').then(m => (
        <PageShareTitle title="Security insights">
          <Content>
            <m.DependabotAlertsContent />
          </Content>
        </PageShareTitle>
      )),
  },
});
